import { EmployeeListItem } from "@/components/employee/EmployeeListItem.tsx";
import { PerformanceReviewReviewerTypeSummaries } from "@/pages/talent/performance-reviews/view/components/PerformanceReviewReviewerTypeSummaries.tsx";
import { ScoreTag } from "@/pages/talent/performance-reviews/view/components/ScoreTag.tsx";
import { usePerformanceReviewParticipantSummaryDetails } from "@/queries/performance-reviews/use-performance-reviews.query.ts";
import { Box, Modal, ModalProps, Skeleton, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";

export interface PerformanceReviewParticipantSummaryModalProps extends ModalProps {
  performance_review_id: number;
  employee_id: number;
}

export function PerformanceReviewParticipantSummaryModal({
  performance_review_id,
  employee_id,
  ...props
}: PerformanceReviewParticipantSummaryModalProps) {
  const { t } = useTranslation();

  const { data: participant, isLoading: isLoading } = usePerformanceReviewParticipantSummaryDetails(
    performance_review_id,
    employee_id
  );

  return (
    <Modal
      title={t("performance_review:performance_review")}
      variant={"side"}
      layout={"stretch"}
      withCloser={true}
      {...props}
    >
      {!isLoading && participant ? (
        <Stack gap={"2xl"}>
          <EmployeeListItem
            employee={participant.employee}
            size={"xl"}
            valueSlot={<ScoreTag score={participant.summary.rating.avg_scale_score} size={"xl"} />}
          />
          <Stack gap={"smd"}>
            <Stack direction={"horizontal"}>
              <Text className={"text-title"} size={"xl"}>
                {t("common:of", {
                  current: participant.summary.completed_count,
                  total: t("plurals:feedbacks_completed_count", {
                    count: participant.summary.total_count,
                  }),
                })}
              </Text>
              <Stack direction={"horizontal"} className={"ml-auto"}>
                <Text className={"text-title"} size={"xl"}>
                  {participant.summary.total_count > 0
                    ? `${((participant.summary.completed_count / participant.summary.total_count) * 100).toFixed()}%`
                    : "-"}
                </Text>
              </Stack>
            </Stack>
            <Box
              className={twMerge("h-1 rounded-xs bg-dark/10 w-full px-2 overflow-hidden relative")}
            >
              <Box
                style={{
                  width:
                    participant.summary.total_count == 0
                      ? 0
                      : (participant.summary.completed_count / participant.summary.total_count) *
                          100 +
                        "%",
                }}
                className={twMerge("absolute left-0 h-full rounded-xs bg-brand-dark")}
              />
            </Box>
          </Stack>

          <PerformanceReviewReviewerTypeSummaries
            reviewerTypeSummaries={participant.reviewer_type_summaries}
          />
        </Stack>
      ) : (
        <Skeleton className={"h-30"} />
      )}
    </Modal>
  );
}
